import React from 'react'
import { useGetActivitiesQuery } from '../../../../shared/queries/useGetActivitiesQuery'
import LoadingBackdrop from '../../../../shared/components/LoadingBackdrop/LoadingBackdrop'
import { Stack, Fade } from '@mui/material'
// import { DeletedActivitiesCard } from './components/DeletedActivitiesCard'
import GanttChart from '../../../../shared/components/GanttChart/GanttChart'
import DeliverablesDonutCharts from './components/DeliverablesDonutCharts'
import ActivityByFunctionDonutCharts from './components/ActivityByFunctionDonutCharts'
import useActivityMetrics from './useActivityMetrics'
import useDeliverableMetrics from './useDeliverableMetrics'
import { useStrategy } from '../../../../shared/hooks/useStrategy'

const ActivityMetricsTab = () => {
    const getActivitiesQuery = useGetActivitiesQuery()
    const getActivityMetricsQuery = useActivityMetrics()
    const getDeliverableMetricsQuery = useDeliverableMetrics()

    const strategy = useStrategy()

    if (getActivitiesQuery.isLoading || getActivityMetricsQuery.isLoading || getDeliverableMetricsQuery.isLoading) {
        return <LoadingBackdrop loading title="Metrics" subtitle="Loading Activity Metrics" />
    }

    return (
        <Fade in timeout={800}>
            <Stack direction="column">
                <Stack direction={{ xs: 'column', lg: 'row' }} gap={3} mb={6}>
                    <ActivityByFunctionDonutCharts />
                    {/*<DeletedActivitiesCard />*/}
                </Stack>

                <GanttChart key={strategy._id} activities={getActivitiesQuery.data} />

                <DeliverablesDonutCharts />
            </Stack>
        </Fade>
    )
}

export default ActivityMetricsTab
